import React from 'react';
import { useTranslation } from 'react-i18next';

const Welcome = () => {
    const { t } = useTranslation(['common']);

    return (
        <div>
            <h1>{t('help.title', { ns: 'common' })}</h1>
            <p>{t('help.text1', { ns: 'common' })}</p>
        </div>
    )
}

export default Welcome;
